import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";
import "./styles/fonts.css"; // Importamos las fuentes personalizadas
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Alojamiento from "./pages/Alojamiento/Alojamiento";
import AthosPampa from "./pages/AthosPampa";
import Galeria from "./pages/Galeria/Galeria";
import Contacto from "./pages/Contacto";
import ComoLlegar from "./pages/ComoLlegar/ComoLlegar";
import NuestrosHuspedes from "./pages/NuestrosHuspedes";
import Experiencias from "./pages/Experiencias/Experiencias";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          className="App"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Header />
          <main
            style={{
              padding: "20px",
              flex: 1,
            }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/alojamiento" element={<Alojamiento />} />
              <Route path="/experiencias" element={<Experiencias />} />
              <Route path="/como-llegar" element={<ComoLlegar />} />
              <Route path="/athospampa" element={<AthosPampa />} />
              <Route path="/nuestros-huspedes" element={<NuestrosHuspedes />} />
              <Route path="/galeria" element={<Galeria />} />
              <Route path="/contacto" element={<Contacto />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
